/*
  ######          ######## ##     ##  ######  ##
 ##               ##         ## ##   ##       ##
 ##       ####### ######      ###    ##       ##
 ##               ##         ## ##   ##       ##
  ######          ######## ##     ##  ######  ########

// クリックされたとき、属するグループのクラスを非アクティブにし、指定ターゲットだけアクティブにする
<button type="button" class="js-clickExclActive" data-excl-group="hogeGroup" data-excl-target="fugaTarget"></button>
<div class="js-clickExclActive-group--hogeGroup js-clickExclActive-target--fugaTarget"></div>
*/
if (document.getElementById('page-monthly-senior')) {
  scFilter()
}

function scFilter() {
  if (document.getElementsByClassName('js-clickExclActive')[0]) {
    window.addEventListener('click', function (e) {
      if (!e.target.classList.contains('js-clickExclActive')) {
        return
      }
      const group = e.target.dataset.exclGroup
      const target = e.target.dataset.exclTarget
      exclActive(group, target, 'active')
    })
  }
  function exclActive(group, target, className = 'active') {
    const hide = document.getElementsByClassName('js-clickExclActive-group--' + group)
    for (let index = 0; index < hide.length; index++) {
      hide[index].classList.remove(className)
    }
    const view = document.getElementsByClassName('js-clickExclActive-target--' + target)
    for (let index = 0; index < view.length; index++) {
      view[index].classList.add(className)
    }
  }
}
